import * as actions from "actions/accessCard";

export default (state = null, { type, payload }) => {
  switch (type) {
    case actions.DELETE_ONE_SUCCESS:
    case actions.DELETE_ONE: {
      return null;
    }

    case actions.DELETE_ONE_FAILED: {
      return payload.error;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/accessCard/deleteErrors.js